import Register from '../Register.vue'

export default [
    {
        path: '/register', 
        name: '/register', 
        meta: { layout: 'blank' }, 
        component: Register,
    }
]